import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  Card,
  Container,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { changePasswordUserManagement } from "../../../redux/reducer/userManagement/userManagementReducer";

const useStyle = makeStyles(() => ({
  titleCard: {
    marginTop: "20px",
    padding: "10px",
    background: "#F2F2F2",
  },
  formControlStyle: {
    display: "flex",
    alignItems: "center",
    justifyItems: "flex-start",
    width: "100%",
    margin: "10px 0px",
    flexDirection: "row",
    background: "none",
  },
}));

export default function UserManagementChangePassword() {
  // Routing
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyle();

  // Redux
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  // Local State
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    passwordConfirmation: "",
  });
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    passwordConfirmation: false,
  });

  const handleShowNewPassword = () => {
    setShowPassword({
      ...showPassword,
      newPassword: !showPassword.newPassword,
    });
  };

  const handleShowOldPassword = () => {
    setShowPassword({
      ...showPassword,
      oldPassword: !showPassword.oldPassword,
    });
  };

  const handleShowConfirmPassword = () => {
    setShowPassword({
      ...showPassword,
      passwordConfirmation: !showPassword.passwordConfirmation,
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleValidation = () => {
    if (
      formData.oldPassword.length > 4 &&
      formData.newPassword.length > 4 &&
      formData.newPassword === formData.passwordConfirmation
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      Swal.fire({
        title: `Mohon dicek kembali data yang akan di input`,
        icon: "warning",
        buttons: true,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tambah",
        cancelButtonText: "Batal",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          let data = {
            value: {
              ...formData,
              id: id,
            },
            token: token,
          };
          dispatch(changePasswordUserManagement(data)).then((res) => {
            if (res.payload.status === 200) {
              navigate("/admin/user-management");
            } else {
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: res.payload.message,
              });
            }
          });
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Mohon cek kembali data yang sudah di input",
      });
    }
  };

  return (
    <Container>
      <Card className={styles.titleCard}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          UBAH PASSWORD
        </Typography>
      </Card>
      <Card className={styles.titleCard}>
        <form onSubmit={handleSubmit}>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PASSWORD LAMA
            </Typography>
            <TextField
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={handleShowOldPassword}
                  >
                    <IconButton>
                      {showPassword.oldPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              type={showPassword.oldPassword ? "text" : "password"}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 20,
                style: { background: "white" },
              }}
              required
              helperText={
                formData.oldPassword.length > 0
                  ? formData.oldPassword.length < 4
                    ? "*Password harus melebihi 4 karakter"
                    : ""
                  : ""
              }
              size="small"
              error={
                formData.oldPassword.length > 0
                  ? formData.oldPassword.length < 4
                    ? true
                    : false
                  : false
              }
              name="oldPassword"
              onChange={handleChange}
              value={formData.oldPassword}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PASSWORD BARU
            </Typography>
            <TextField
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={handleShowNewPassword}
                  >
                    <IconButton>
                      {showPassword.newPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              type={showPassword.newPassword ? "text" : "password"}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 20,
                style: { background: "white" },
              }}
              required
              helperText={
                formData.newPassword.length > 0
                  ? formData.newPassword.length < 4
                    ? "*Password harus melebihi 4 karakter"
                    : ""
                  : ""
              }
              size="small"
              error={
                formData.newPassword.length > 0
                  ? formData.newPassword.length < 4
                    ? true
                    : false
                  : false
              }
              name="newPassword"
              onChange={handleChange}
              value={formData.newPassword}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <FormControl className={styles.formControlStyle}>
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KONFIRMASI PASSWORD BARU
            </Typography>
            <TextField
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={handleShowConfirmPassword}
                  >
                    <IconButton>
                      {showPassword.passwordConfirmation ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              type={showPassword.passwordConfirmation ? "text" : "password"}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 20,
                style: { background: "white" },
              }}
              required
              helperText={
                formData.passwordConfirmation.length > 0
                  ? formData.passwordConfirmation !== formData.newPassword
                    ? "*Password tidak sama"
                    : ""
                  : ""
              }
              size="small"
              error={
                formData.passwordConfirmation.length > 0
                  ? formData.passwordConfirmation !== formData.newPassword
                    ? true
                    : false
                  : false
              }
              name="passwordConfirmation"
              onChange={handleChange}
              value={formData.passwordConfirmation}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <div>
            <Button type="submit" variant="contained">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: 5 }}
              onClick={() => navigate("/admin/user-management")}
            >
              CANCEL
            </Button>
          </div>
        </form>
      </Card>
    </Container>
  );
}
